import React, { useState, useEffect, useRef } from "react";
import ReactTooltip from "react-tooltip";
import { Calendar } from "primereact/calendar";
import { Toast } from "primereact/toast";
import { Link, useHistory } from "react-router-dom";
import axios from "axios";
import { useDispatch, useSelector } from "react-redux";
import { VAAction } from "../../store/actions/VAAction";
import { Dialog } from "primereact/dialog";
import { InputTextarea } from "primereact/inputtextarea";
import { Dropdown } from "primereact/dropdown";
import { InputText } from "primereact/inputtext";
import { Button } from "primereact/button";
import "../../config";
import qs from "query-string";
import { countryRequest } from "../common/customServiceCall/serviceCall";

const checkHistory = "assets/layout/images/refresh.png";
const topUp = "assets/layout/images/topup.png";
const deduct = "assets/layout/images/topdown.png";
const addForex = "assets/layout/images/forex_add.png";

const VAcc = ({ userId }) => {
  // Refs
  const toastBR = useRef(null);
  const buttonRef = useRef(null);
  const history = useHistory();
  const dispatch = useDispatch();

  // Redux state
  const userDetails = useSelector((state) => state.login.userDetails);
  const vaData = useSelector((state) => state.login.vaData);

  // Component state
  const [countries, setCountries] = useState([]);
  const [vaName, setVaName] = useState("");
  const [currency, setCurrency] = useState("");
  const [vaThreshold, setVaThreshold] = useState(0);
  const [amount, setAmount] = useState(0);
  const [purpose, setPurpose] = useState("");
  const [deductAmount, setDeductAmount] = useState(0);
  const [deductPurpose, setDeductPurpose] = useState("");
  const [vaId, setVaId] = useState("");

  // UI state
  const [showBox, setShowBox] = useState("none");
  const [dropdownAccountType, setDropdownAccountType] = useState("");
  const [dropdownCountry, setDropdownCountry] = useState("");
  const [currencyValue, setCurrencyValue] = useState("");
  const [institutionName, setInstitutionName] = useState("");
  const [accountName, setAccountName] = useState("");
  const [items, setItems] = useState([]);
  const [data, setData] = useState([]);

  // Dialog states
  const [topUpDialog, setTopUpDialog] = useState(false);
  const [deducationDialog, setDeducationDialog] = useState(false);
  const [viewVirtualAccountDialog, setViewVirtualAccountDialog] =
    useState(false);
  const [dialogVisible, setDialogVisible] = useState(false);

  // Loading states
  const [requestInProgress, setRequestInProgress] = useState(false);
  const [showLoader, setShowLoader] = useState("none");

  // Filter states
  const [showFiltersWeb, setShowFiltersWeb] = useState("none");
  const [showFiltersMob, setShowFiltersMob] = useState("none");
  const [filterDate, setFilterDate] = useState(null);
  const [dateChange, setDateChange] = useState("N");

  // Error states
  const [vaNameError, setVaNameError] = useState("");
  const [accountTypeError, setAccountTypeError] = useState("");
  const [vaThresholdError, setVaThresholdError] = useState("");
  const [currencyError, setCurrencyError] = useState("");
  const [topUpAmountError, setTopUpAmountError] = useState("");
  const [topUpPurposeError, setTopUpPurposeError] = useState("");
  const [deductAmountError, setDeductAmountError] = useState("");
  const [deductPurposeError, setDeductPurposeError] = useState("");

  // Constants
  const accountType = [
    { label: "All", value: "2" },
    { label: "Bank", value: "0" },
    { label: "Wallet", value: "1" },
  ];

  const toastSuccess = (msg) => {
    toastBR.current.show({
      severity: "success",
      summary: "",
      detail: msg,
      life: 5000,
    });
  };

  const toastError = (msg) => {
    toastBR.current.show({
      severity: "error",
      summary: "",
      detail: msg,
      life: 5000,
    });
  };

  // API calls
  const fetchData = async () => {
    try {
      const response = await countryRequest("get", `api/v1/countries/list-all?page=1&size=300`);
      if (response.code === "00") {
        const formattedCountries = response.data.map((country) => ({
          id: country.id,
          label: country.name,
          value: country.name,
          currency: country.currency,
        }));
        setCountries(formattedCountries || []);
      } else {
        setCountries([]);
        console.error("Failed to fetch data:", response.message);
      }
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };

  const getVirtualAccountData = async () => {
    const config = {
      headers: {
        "Content-Type": "application/x-www-form-urlencoded",
      },
    };

    const data = {
      userId: vaData?.userid || userId,
      token: userDetails?._id,
    };

    try {
      const res = await axios.post(
        `${global.config.main.baseUrl}list-va`,
        qs.stringify(data),
        config
      );

      if (res.data.status === 200) {
        if (!res.data.data) {
          toastSuccess("No Virtual Account created");
          setShowBox("none");
        } else {
          const vaItems = res.data.data.map((d) => (
            <div className="p-col-12 p-md-6 p-xl-3" key={d.vaID}>
              <div className="highlight-box">
                <div className="highlight-details">
                  <span style={cardHeadingStyle}>{d.accountName}</span>
                  <span
                    className="count"
                    data-tip={`${d.currency} ${
                      d.balance?.toLocaleString() || 0
                    }`}
                    data-for="toolTip1"
                    data-place="top"
                    style={{
                      paddingTop: "1em",
                      wordWrap: "break-word",
                      display: "inline-block",
                      maxWidth: "100%",
                    }}
                  >
                    {d.currency}&nbsp;{d.balance?.toLocaleString() || 0}
                  </span>
                  <ReactTooltip id="toolTip1" />
                  <div className="p-grid cardFooter">
                    <div className="p-col-7 p-md-8 p-lg- p-xl-6"></div>
                    <div className="p-col-5 p-md-4 p-lg-4 p-xl-6">
                      <button
                        style={topupButtonStyle}
                        onClick={() => openTopUpDialog(d.vaID, d.account_name)}
                      >
                        <span>
                          <img
                            src={topUp}
                            alt="top up"
                            style={{ width: "10px" }}
                          />
                        </span>
                        <span style={{ fontSize: "12px" }}>Top up</span>
                      </button>
                    </div>
                  </div>
                  <div className="p-grid">
                    <div className="p-col-7 p-md-8 p-lg- p-xl-6">
                      <span
                        className="detail span-custom-success"
                        style={detailsStyle}
                      >
                        <img
                          src={checkHistory}
                          style={{ height: "15px", width: "15px" }}
                          alt="history"
                        />
                        <Link
                          to="/va-history"
                          onClick={() => navigate2VAHistory(d.vaID)}
                          style={{ color: "rgb(189, 220, 254)" }}
                        >
                          Check History
                        </Link>
                      </span>
                    </div>
                    <div className="p-col-5 p-md-4 p-lg-4 p-xl-6">
                      <button
                        style={topupButtonStyle}
                        onClick={() => openDeductDialog(d.vaID, d.account_name)}
                      >
                        <span>
                          <img
                            src={deduct}
                            alt="deduct"
                            style={{ width: "10px" }}
                          />
                        </span>
                        <span style={{ fontSize: "12px" }}>Deduct</span>
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          ));

          setShowBox("flex");
          setData(res.data.data);
          setItems(vaItems);
          setInstitutionName(res.data.name || "");
        }
      }
    } catch (error) {
      if (!error.response) {
        toastError("A network error occurred");
      }
    }
  };

  // Dialog handlers
  const openTopUpDialog = (vaId, acName) => {
    setVaId(vaId);
    console.log("vaId", vaId);
    setAccountName(acName);
    setTopUpDialog(true);
  };

  const hideTopUpDialog = () => {
    setAmount(0);
    setPurpose("");
    setTopUpDialog(false);
  };

  const openDeductDialog = (vaId, acName) => {
    setVaId(vaId);
    setAccountName(acName);
    setDeducationDialog(true);
  };

  const hideDeductionDialog = () => {
    setDeductAmount(0);
    setDeductPurpose("");
    setDeducationDialog(false);
  };

  const showVirtualAccountDialog = () => {
    setViewVirtualAccountDialog(true);
  };

  const hideVirtualAccountDialog = () => {
    setVaName("");
    setVaThreshold(0);
    setDropdownAccountType("");
    setDropdownCountry("");
    setViewVirtualAccountDialog(false);
  };

  // Form handlers
  const createVirtualAccount = async (event) => {
    event.preventDefault();

    // Reset errors
    setVaNameError("");
    setAccountTypeError("");
    setVaThresholdError("");
    setCurrencyError("");

    // Validation
    let isValid = true;
    if (!vaName) {
      setVaNameError("1.5px solid red");
      isValid = false;
    }
    if (!dropdownAccountType) {
      setAccountTypeError("1.5px solid red");
      isValid = false;
    }
    if (!vaThreshold || vaThreshold <= 0) {
      setVaThresholdError("1.5px solid red");
      isValid = false;
    }
    if (!dropdownCountry) {
      setCurrencyError("1.5px solid red");
      isValid = false;
    }

    if (!isValid) return;

    const selectedCountry = countries.find(
      (country) => country.value === dropdownCountry
    );

    const requestData = {
      userId: vaData?.userid || userId,
      account_name: vaName,
      account_type: dropdownAccountType,
      threshold_amount: vaThreshold,
      country_name: dropdownCountry,
      currency: currency || selectedCountry?.currency || "",
      token: userDetails?._id,
      country_id: selectedCountry?.id
    };
    console.log(requestData)

    try {
      const res = await axios.post(
        `${global.config.main.baseUrl}create-va`,
        qs.stringify(requestData),
        {
          headers: {
            "Content-Type": "application/x-www-form-urlencoded",
          },
        }
      );

      if (res.data.status === 200) {
        getVirtualAccountData();
        hideVirtualAccountDialog();
        toastSuccess(res.data.msg);
      } else {
        toastError(res.data.msg);
      }
    } catch (error) {
      console.error("Error creating virtual account:", error);
      if (!error.response) {
        toastError("A network error occurred");
      } else {
        toastError(
          error.response.data.message || "Failed to create virtual account"
        );
      }
    }
  };

  const topUpVirtualAccount = async (event) => {
    event.preventDefault();

    if (requestInProgress) return;

    // Reset errors
    setTopUpAmountError("");
    setTopUpPurposeError("");

    let isValid = true;
    if (!amount || amount <= 0) {
      setTopUpAmountError("1.5px solid red");
      isValid = false;
    }
    if (!purpose) {
      setTopUpPurposeError("1.5px solid red");
      isValid = false;
    }

    if (!isValid) return;

    setRequestInProgress(true);
    if (buttonRef.current) buttonRef.current.disabled = true;

    const config = {
      headers: {
        "Content-Type": "application/x-www-form-urlencoded",
      },
    };

    const requestData = {
      request_type: 0,
      va_id: vaId,
      amount: amount,
      description: purpose,
      token: userDetails?._id,
    };

    try {
      const res = await axios.post(
        `${global.config.main.baseUrl}va-adjustment-add`,
        qs.stringify(requestData),
        config
      );

      if (res.data.status === 200) {
        hideTopUpDialog();
        getVirtualAccountData();
        toastSuccess(res.data.msg);
      } else {
        toastError(res.data.msg);
      }
    } catch (error) {
      if (!error.response) {
        toastError("A network error occurred");
      }
    } finally {
      setRequestInProgress(false);
      if (buttonRef.current) buttonRef.current.disabled = false;
    }
  };

  const deductVirtualAccount = async (event) => {
    event.preventDefault();

    if (requestInProgress) return;

    // Reset errors
    setDeductAmountError("");
    setDeductPurposeError("");

    let isValid = true;
    if (!deductAmount || deductAmount <= 0) {
      setDeductAmountError("1.5px solid red");
      isValid = false;
    }
    if (!deductPurpose) {
      setDeductPurposeError("1.5px solid red");
      isValid = false;
    }

    if (!isValid) return;

    setRequestInProgress(true);
    if (buttonRef.current) buttonRef.current.disabled = true;

    const config = {
      headers: {
        "Content-Type": "application/x-www-form-urlencoded",
      },
    };

    const requestData = {
      request_type: 1,
      va_id: vaId,
      amount: deductAmount,
      description: deductPurpose,
      token: userDetails?._id,
    };

    try {
      const res = await axios.post(
        `${global.config.main.baseUrl}va-adjustment-add`,
        qs.stringify(requestData),
        config
      );

      if (res.data.status === 200) {
        hideDeductionDialog();
        getVirtualAccountData();
        toastSuccess(res.data.msg);
      } else {
        toastError(res.data.msg);
      }
    } catch (error) {
      if (!error.response) {
        toastError("A network error occurred");
      }
    } finally {
      setRequestInProgress(false);
      if (buttonRef.current) buttonRef.current.disabled = false;
    }
  };

  const navigate2VAHistory = (id) => {
    dispatch(VAAction({ vaid: id })).then((result) => {
      if (result?.success) {
        history.push("/va-history");
      } else {
        toastError("Failed to navigate to VA history");
      }
    });
  };

  // Window resize handler
  const updateDimensions = () => {
    if (window.innerWidth < 1025) {
      setShowFiltersWeb("none");
      setShowFiltersMob("flex");
    } else {
      setShowFiltersWeb("flex");
      setShowFiltersMob("none");
    }
  };

  useEffect(() => {
    document.title = "Virtual Accounts - Instant Credit";
    getVirtualAccountData();
    fetchData();
    updateDimensions();

    window.addEventListener("resize", updateDimensions);
    return () => {
      window.removeEventListener("resize", updateDimensions);
    };
  }, []);

  // Styles
  const cardStyle = {};
  const detailsStyle = {
    fontSize: "8px",
    paddingTop: "0.8em",
    color: "rgb(189,220,254)",
  };
  const detailsStyle1 = {
    fontSize: "14px",
    paddingTop: "0.4em",
    color: "rgb(92, 74, 181)",
    float: "right",
  };
  const buttonDetailsStyle = { fontSize: "10px" };
  const topupButtonStyle = {
    padding: "5px",
    background: "rgb(92, 74, 181)",
    border: "0",
    color: "#fff",
    paddingRight: "10px",
    float: "right",
    width: "80%",
  };
  const cardHeadingStyle = {
    color: "#5c4ab5",
    fontWeight: "600",
    position: "absolute",
  };
  const filterInputBoxStyle = { borderRadius: "4px" };
  const labelStyle = {
    paddingLeft: "10px",
    fontSize: "12px",
    color: "#999",
    fontWeight: "500",
  };
  const amountBorder = {
    borderBottomLeftRadius: "10px",
    borderTopLeftRadius: "10px",
  };
  const vaNameborder = { border: vaNameError };

  return (
    <div>
      <Toast ref={toastBR} position="top-right" />
      <div className="p-grid p-fluid" style={{ marginTop: "20px" }}>
        <div className="p-col-12 p-md-12 p-xl-12">
          <div className="p-grid p-fluid">
            <div
              className="p-col-12 p-md-4 p-xl-4 p-md-offset-4 p-xl-offset-4"
              style={{ textAlign: "center" }}
            >
              <span className="p-tag custom-heading">Virtual Accounts</span>
            </div>
          </div>
          <div className="p-grid transaction">
            <div
              className="p-col-12 p-md-10 p-xl-10 p-md-offset-1 p-lg-offset-1 p-xl-offset-1 card"
              style={{ paddingBottom: "10px", paddingTop: "20px" }}
            >
              <div
                className="p-grid p-fluid"
                style={{ display: showFiltersMob }}
              >
                <div className="p-field p-col-6 p-md-6 p-lg-6 p-xl-6">
                  <Link to="/institution-list">
                    <span
                      className="p-tag custom-heading"
                      style={{ fontSize: "15px" }}
                    >
                      {institutionName}
                    </span>
                  </Link>
                </div>
                <div className="p-field p-col-6 p-md-6 p-lg-6 p-xl-6">
                  <span
                    className="detail span-custom-success"
                    style={detailsStyle1}
                  >
                    Add VA&nbsp;
                    <img
                      src={addForex}
                      style={{ height: "25px", width: "25px" }}
                      onClick={showVirtualAccountDialog}
                      alt="Add Virtual Account"
                    />
                  </span>
                </div>
              </div>
              <div
                className="p-grid p-fluid"
                style={{ display: showFiltersWeb }}
              >
                <div className="p-field p-col-6 p-md-3 p-xl-3">
                  <span className="p-float-label">
                    <Link to="/institution-list">
                      <span
                        className="p-tag custom-heading"
                        style={{ fontSize: "15px" }}
                      >
                        {institutionName}
                      </span>
                    </Link>
                  </span>
                </div>
                <div className="p-field p-col-6 p-md-3 p-xl-3"></div>
                <div className="p-col-12 p-md-4 p-xl-4"></div>
                <div className="p-col-4 p-md-2 p-xl-2">
                  <span
                    className="detail span-custom-success"
                    style={detailsStyle1}
                  >
                    Add VA &nbsp;
                    <img
                      src={addForex}
                      style={{ height: "25px", width: "25px" }}
                      onClick={showVirtualAccountDialog}
                      alt="Add Virtual Account"
                    />
                  </span>
                </div>
              </div>
            </div>
          </div>

          <div
            className="p-col-12 p-md-10 p-xl-10 p-md-offset-1 p-lg-offset-1 p-xl-offset-1"
            style={{ padding: "0px" }}
          >
            <div className="p-grid p-fluid card" style={{ display: showBox }}>
              {items}
            </div>
          </div>
        </div>
      </div>
      <Dialog
        header="Filters"
        visible={dialogVisible}
        onHide={() => setDialogVisible(false)}
      >
        <div className="p-grid">
          <div
            className="p-field p-col-12 p-md-8 p-md-offset-2"
            style={{ marginTop: "1.5em" }}
          >
            <span className="p-float-label">
              <Calendar
                inputStyle={filterInputBoxStyle}
                id="calendar"
                value={new Date()}
                onChange={(e) => {
                  setFilterDate(e.value);
                  setDateChange("Y");
                }}
                showIcon={true}
                style={{ width: "100%" }}
              />
              <label htmlFor="calendar">DATE</label>
            </span>
          </div>
        </div>
      </Dialog>
      <Dialog
        visible={topUpDialog}
        style={{ width: "450px" }}
        header="Top Up Account"
        modal
        onHide={hideTopUpDialog}
      >
        <form onSubmit={topUpVirtualAccount}>
          <div className="p-grid p-fluid transaction">
            <div className="p-col-12 p-sm-12 p-md-12 p-lg-12 p-xl-12">
              <div className="p-grid p-fluid">
                <div
                  className="p-col-12 p-md-10 p-lg-10 p-xl-10 p-md-offset-1 p-lg-offset-1 p-xl-offset-1"
                  style={{ marginTop: "20px" }}
                >
                  <span className="p-float-label">
                    <InputText
                      value={accountName}
                      style={{ color: "#8c8c8c", backgroundColor: "#d4d4d4" }}
                      readOnly
                    />
                    <label htmlFor="dropdown1" style={labelStyle}>
                      Account Name
                    </label>
                  </span>
                </div>
                <div
                  className="p-col-12 p-md-10 p-lg-10 p-xl-10 p-md-offset-1 p-lg-offset-1 p-xl-offset-1"
                  style={{ marginTop: "20px" }}
                >
                  <div className="p-inputgroup">
                    <span className="p-float-label">
                      <div className="p-inputgroup">
                        <InputText
                          value={amount}
                          onChange={(e) => setAmount(e.target.value)}
                          type="number"
                          min="0.01"
                          step="0.01"
                          style={{ border: topUpAmountError }}
                        />
                        <span
                          className="p-inputgroup-addon"
                          style={{
                            border: "0",
                            backgroundColor: "#5c4ab5",
                            color: "#fff",
                            borderTopRightRadius: "10px",
                            borderBottomRightRadius: "10px",
                          }}
                        >
                          ₵
                        </span>
                        <label htmlFor="dropdown1" style={labelStyle}>
                          Amount
                        </label>
                      </div>
                    </span>
                  </div>
                </div>
                <div
                  className="p-col-12 p-md-10 p-lg-10 p-xl-10 p-md-offset-1 p-lg-offset-1 p-xl-offset-1"
                  style={{ marginTop: "20px" }}
                >
                  <span className="p-float-label">
                    <InputTextarea
                      id="purpose"
                      rows={3}
                      cols={30}
                      autoResize={true}
                      value={purpose}
                      onChange={(e) => setPurpose(e.target.value)}
                      style={{ border: topUpPurposeError }}
                    />
                    <label htmlFor="dropdown1" style={labelStyle}>
                      Description
                    </label>
                  </span>
                </div>
              </div>
            </div>
          </div>
          <div className="p-grid p-fluid">
            <div
              className="p-col-12 p-md-12 p-lg-12 p-xl-12"
              style={{ textAlign: "center" }}
            >
              <Button
                label="Request Top Up"
                className="p-button-info"
                type="submit"
                disabled={requestInProgress}
                ref={buttonRef}
                style={{ width: "60%", marginTop: "1.5em" }}
              />
            </div>
          </div>
        </form>
      </Dialog>
      <Dialog
        visible={deducationDialog}
        style={{ width: "450px" }}
        header="Deduct Account"
        modal
        onHide={hideDeductionDialog}
      >
        <form onSubmit={deductVirtualAccount}>
          <div className="p-grid p-fluid transaction">
            <div className="p-col-12 p-sm-12 p-md-12 p-lg-12 p-xl-12">
              <div className="p-grid p-fluid">
                <div
                  className="p-col-12 p-md-10 p-lg-10 p-xl-10 p-md-offset-1 p-lg-offset-1 p-xl-offset-1"
                  style={{ marginTop: "20px" }}
                >
                  <span className="p-float-label">
                    <InputText
                      value={accountName}
                      readOnly
                      style={{ color: "#8c8c8c", backgroundColor: "#d4d4d4" }}
                    />
                    <label style={labelStyle}>Account Name</label>
                  </span>
                </div>
                <div
                  className="p-col-12 p-md-10 p-lg-10 p-xl-10 p-md-offset-1 p-lg-offset-1 p-xl-offset-1"
                  style={{ marginTop: "20px" }}
                >
                  <div className="p-inputgroup">
                    <span className="p-float-label">
                      <div className="p-inputgroup">
                        <InputText
                          type="number"
                          value={deductAmount}
                          onChange={(e) => setDeductAmount(e.target.value)}
                          style={{
                            border: deductAmountError,
                            borderTopLeftRadius: "10px",
                            borderBottomLeftRadius: "10px",
                          }}
                          min="0.01"
                          step="0.01"
                        />
                        <span
                          className="p-inputgroup-addon"
                          style={{
                            border: "0",
                            backgroundColor: "#5c4ab5",
                            color: "#fff",
                            borderTopRightRadius: "10px",
                            borderBottomRightRadius: "10px",
                          }}
                        >
                          ₵
                        </span>
                        <label htmlFor="dropdown1" style={labelStyle}>
                          Amount
                        </label>
                      </div>
                    </span>
                  </div>
                </div>
                <div
                  className="p-col-12 p-md-10 p-lg-10 p-xl-10 p-md-offset-1 p-lg-offset-1 p-xl-offset-1"
                  style={{ marginTop: "20px" }}
                >
                  <span className="p-float-label">
                    <InputTextarea
                      id="purpose"
                      rows={3}
                      cols={30}
                      autoResize={true}
                      value={deductPurpose}
                      onChange={(e) => setDeductPurpose(e.target.value)}
                      style={{ border: deductPurposeError }}
                    />
                    <label htmlFor="dropdown1" style={labelStyle}>
                      Description
                    </label>
                  </span>
                </div>
              </div>
            </div>
          </div>
          <div className="p-grid p-fluid" style={{ textAlign: "center" }}>
            <div className="p-col-12 p-md-12 p-lg-12 p-xl-12">
              <Button
                label="Request Deduction"
                className="p-button-info"
                disabled={requestInProgress}
                ref={buttonRef}
                type="submit"
                style={{ width: "62%", marginTop: "1.5em" }}
              />
            </div>
          </div>
        </form>
      </Dialog>
      <Dialog
        visible={viewVirtualAccountDialog}
        style={{ width: "450px" }}
        header="Create Virtual Account"
        modal
        onHide={hideVirtualAccountDialog}
      >
        <form onSubmit={createVirtualAccount}>
          <div className="p-grid p-fluid">
            <div className="p-col-12 p-sm-12 p-md-12 p-lg-12 p-xl-12">
              <div className="p-grid p-fluid">
                <div
                  className="p-col-12 p-md-10 p-lg-10 p-xl-10 p-md-offset-1 p-lg-offset-1 p-xl-offset-1"
                  style={{ marginTop: "20px" }}
                >
                  <span className="p-float-label">
                    <InputText
                      name="vaName"
                      value={vaName}
                      onChange={(e) => setVaName(e.target.value)}
                      style={{ border: vaNameError }}
                    />
                    <label htmlFor="dropdown1" style={labelStyle}>
                      Virtual Account Name
                    </label>
                  </span>
                </div>
                 <div
                  className="p-col-12 p-md-10 p-lg-10 p-xl-10 p-md-offset-1 p-lg-offset-1 p-xl-offset-1"
                  style={{ marginTop: "20px" }}
                >
                  <span className="p-float-label">
                    <InputText
                      name="currency"
                      value={currency}
                      onChange={(e) => setCurrency(e.target.value)}
                    />
                    <label htmlFor="dropdown1" style={labelStyle}>
                      Currency (Optional)
                    </label>
                  </span>
                </div>
                <div
                  className="p-col-12 p-md-10 p-lg-10 p-xl-10 p-md-offset-1 p-lg-offset-1 p-xl-offset-1"
                  style={{
                    marginTop: "10px",
                    border: accountTypeError,
                  }}
                >
                  <span className="p-float-label">
                    <Dropdown
                      style={filterInputBoxStyle}
                      id="dropdown1"
                      options={accountType}
                      value={dropdownAccountType}
                      onChange={(e) => {
                        setDropdownAccountType(e.value);
                        setAccountTypeError("");
                      }}
                      autoWidth={false}
                    />
                    <label htmlFor="dropdown1" style={labelStyle}>
                      Select Account Type
                    </label>
                  </span>
                </div>
                <div
                  className="p-col-12 p-md-5 p-lg-5 p-xl-5 p-md-offset-1 p-lg-offset-1 p-xl-offset-1"
                  style={{ marginTop: "20px" }}
                >
                  <span className="p-float-label">
                    <InputText
                      type="number"
                      name="vaThreshold"
                      value={vaThreshold}
                      onChange={(e) => {
                        setVaThreshold(e.target.value);
                        setVaThresholdError("");
                      }}
                      style={{ border: vaThresholdError }}
                      min="1"
                    />
                    <label htmlFor="dropdown1" style={labelStyle}>
                      Threshold Amount
                    </label>
                  </span>
                </div>

                <div
                  className="p-col-12 p-md-5 p-lg-5 p-xl-5"
                  style={{
                    marginTop: "20px",
                    border: currencyError,
                  }}
                >
                  <span className="p-float-label">
                    <Dropdown
                      style={filterInputBoxStyle}
                      id="dropdown1"
                      options={countries}
                      value={dropdownCountry}
                      onChange={(e) => {
                        const selectedCountry = countries.find(
                          (country) => country.value === e.value
                        );
                        setDropdownCountry(e.value);
                        setCurrencyValue(selectedCountry?.currency || "");
                        setCurrencyError("");
                      }}
                      optionLabel="label"
                      autoWidth={false}
                    />
                    <label htmlFor="dropdown1" style={labelStyle}>
                      Select Country
                    </label>
                  </span>
                </div>
              </div>
            </div>
          </div>
          <div className="p-grid p-fluid">
            <div
              className="p-col-12 p-md-12 p-lg-12 p-xl-12"
              style={{ textAlign: "center" }}
            >
              <Button
                label="Confirm"
                className="p-button-info"
                type="submit"
                style={{ width: "50%", marginTop: "1.5em" }}
              />
            </div>
          </div>
        </form>
      </Dialog>
    </div>
  );
};

export default VAcc;
